import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { map } from 'rxjs/operators';
import { CustomerStatus } from '../../../shared/store-mocks/status.store';
import { AdvancedFiltersFormStatusAlarisStore } from './advanced-filters-form-status-alaris.store';

@Component({
  selector: 'app-advanced-filters-form-status-alaris',
  templateUrl: './advanced-filters-form-status-alaris.component.html',
  styleUrls: ['./advanced-filters-form-status-alaris.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AdvancedFiltersFormStatusAlarisStore]
})
export class AdvancedFiltersFormStatusAlarisComponent implements OnInit, OnDestroy, ControlValueAccessor {

  onChange: any = () => {}
  onTouch: any = () => {}


  
  statusCurrentValue$ = this.store.statusValue$.pipe(map(
    (value: any) => {
      return value.length ? value.split(',').filter(s => s !== CustomerStatus.NONE) : []
    }
  ))
  statusEntities$ = this.store.entities$

  constructor(
    public ngControl: NgControl,
    private store: AdvancedFiltersFormStatusAlarisStore

    ) {
      ngControl.valueAccessor = this;
    }

  ngOnInit(): void {}

  writeValue(value: string){}

  registerOnChange(fn: any){
    this.onChange = fn
  }

  registerOnTouched(fn: any){
    this.onTouch = fn
  }

  statusValueChange(option: string[]) {
    this.saveValue(option.join(','))
  }


  saveValue(value){
    this.onChange(value)
    if(this.ngControl.untouched){
      this.onTouch()
    }
  }

  ngOnDestroy(){
    this.saveValue('')
  }
}
